import { styled } from '@mui/material';

const Section3Container = styled('div')(({ theme }) => ({
  maxWidth: 1300,
  margin: '0 auto',
  padding: '0 64px 120px 64px',
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  gap: 32,
  [theme.breakpoints.down('md')]: {
    padding: '0 32px 120px 32px',
    gap: 64,
  },
  [theme.breakpoints.down('sm')]: {
    padding: '0 1rem 2.5rem 1rem',
  },
  '& div.header': {
    maxWidth: 600,
    textAlign: 'center',
    h2: {
      fontSize: 32,
      lineHeight: '48px',
      fontWeight: 700,
      marginTop: 32,
      color: '#04246B',
    },
  },
  h5: {
    fontSize: 20,
    lineHeight: '32px',
    fontWeight: 500,
    maxWidth: 1000,
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      maxWidth: 700,
    },
  },
}));

const Section3 = () => (
  <Section3Container>
    <div className="header">
      <svg xmlns="http://www.w3.org/2000/svg" width="100" height="101" viewBox="0 0 100 101" fill="none">
        <circle cx="50" cy="51" r="47" fill="white" stroke="#CDA07D" stroke-width="6" />
        <path
          d="M50 71C53.125 71 55.7817 69.9058 57.97 67.7175C60.1583 65.5292 61.2517 62.8733 61.25 59.75C61.25 56.625 60.1558 53.9683 57.9675 51.78C55.7792 49.5917 53.1233 48.4983 50 48.5C46.875 48.5 44.2183 49.5942 42.03 51.7825C39.8417 53.9708 38.7483 56.6267 38.75 59.75C38.75 62.875 39.8442 65.5317 42.0325 67.72C44.2208 69.9083 46.8767 71.0017 50 71ZM42.6875 45.25C43.5208 44.7917 44.4067 44.4275 45.345 44.1575C46.2833 43.8875 47.2308 43.71 48.1875 43.625L41.875 31H35.625L42.6875 45.25ZM36 68C35.2917 66.7917 34.7392 65.4892 34.3425 64.0925C33.9458 62.6958 33.7483 61.2483 33.75 59.75C33.75 58.25 33.9483 56.8017 34.345 55.405C34.7417 54.0083 35.2933 52.7067 36 51.5C34.25 52.0833 32.8125 53.115 31.6875 54.595C30.5625 56.075 30 57.7933 30 59.75C30 61.7083 30.5625 63.4275 31.6875 64.9075C32.8125 66.3875 34.25 67.4183 36 68ZM64 68C65.75 67.4167 67.1875 66.385 68.3125 64.905C69.4375 63.425 70 61.7067 70 59.75C70 57.7917 69.4375 56.0725 68.3125 54.5925C67.1875 53.1125 65.75 52.0817 64 51.5C64.7083 52.7083 65.2608 54.0108 65.6575 55.4075C66.0542 56.8042 66.2517 58.2517 66.25 59.75C66.25 61.25 66.0517 62.6983 65.655 64.095C65.2583 65.4917 64.7067 66.7933 64 68ZM50 76C48.3333 76 46.7392 75.76 45.2175 75.28C43.6958 74.8 42.29 74.1442 41 73.3125C40.625 73.3958 40.25 73.4483 39.875 73.47C39.5 73.4917 39.1042 73.5017 38.6875 73.5C34.8958 73.5 31.6667 72.1667 29 69.5C26.3333 66.8333 25 63.6042 25 59.8125C25 56.1875 26.2083 53.0833 28.625 50.5C31.0417 47.9167 34.0208 46.4792 37.5625 46.1875L29.3125 29.625C28.8958 28.7917 28.9275 27.9792 29.4075 27.1875C29.8875 26.3958 30.6058 26 31.5625 26H41.9375C42.8958 26 43.7608 26.25 44.5325 26.75C45.3042 27.25 45.9183 27.9167 46.375 28.75L50 36L53.625 28.75C54.0833 27.9167 54.6983 27.25 55.47 26.75C56.2417 26.25 57.1058 26 58.0625 26H68.4375C69.3958 26 70.115 26.3958 70.595 27.1875C71.075 27.9792 71.1058 28.7917 70.6875 29.625L62.5 46.0625C66.0417 46.3958 69.0108 47.8542 71.4075 50.4375C73.8042 53.0208 75.0017 56.125 75 59.75C75 63.5833 73.6667 66.8333 71 69.5C68.3333 72.1667 65.0833 73.5 61.25 73.5C60.875 73.5 60.4892 73.4892 60.0925 73.4675C59.6958 73.4458 59.3108 73.3942 58.9375 73.3125C57.6458 74.1458 56.25 74.8025 54.75 75.2825C53.25 75.7625 51.6667 76.0017 50 76ZM50 63.125L46.9375 65.4375C46.6875 65.6458 46.4375 65.6567 46.1875 65.47C45.9375 65.2833 45.8542 65.0433 45.9375 64.75L47.125 60.9375L44.0625 58.75C43.8125 58.5417 43.7292 58.3017 43.8125 58.03C43.8958 57.7583 44.1042 57.6233 44.4375 57.625H48.1875L49.375 53.5625C49.4583 53.2708 49.6667 53.125 50 53.125C50.3333 53.125 50.5417 53.2708 50.625 53.5625L51.8125 57.625H55.5625C55.8958 57.625 56.1042 57.7608 56.1875 58.0325C56.2708 58.3042 56.1875 58.5433 55.9375 58.75L52.875 60.9375L54.0625 64.75C54.1458 65.0417 54.0625 65.2817 53.8125 65.47C53.5625 65.6583 53.3125 65.6475 53.0625 65.4375L50 63.125ZM57.3125 45.25L64.4375 31H58.125L52.8125 41.625L54 44C54.5833 44.1667 55.1458 44.3442 55.6875 44.5325C56.2292 44.7208 56.7708 44.96 57.3125 45.25Z"
          fill="#CDA07D"
        />
      </svg>
      <h2>Leading the Way with Unmatched Expertise</h2>
    </div>
    <h5>
      With a versatile and impressive background covering custom home building and technology leadership and innovation,
      paired with over 30+ years of successful experience in real estate and lending, The New Home Collection is
      uniquely positioned to achieve superior results and set the bar in the modern real estate industry.
    </h5>
  </Section3Container>
);

export default Section3;
